<template>
    <iframe
        v-if="thirdLoginPageSrc"
        :src="thirdLoginPageSrc"
        title="third register"
        :style="{
            width: '100%',
            height: height + 'px',
            border: 'none',
            overflow: 'hidden'
        }"
    ></iframe>
</template>

<script>

import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { IS_DEBUG } from '@/common/debug.js';
export default {
    emits: ['auth', 'resize'],
    props: {
        theme: {
            type: String,
            default: 'standard'
        },
        enableFb: {
            type: Boolean,
            default: true
        },
        enableGoogle: {
            type: Boolean,
            default: true
        },
        fbBtnText: {
            type: String,
            default: ''
        },
        googleBtnText: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            height: 0,
            mounted: false,
        };
    },
    computed: {
        thirdLoginPageSrc({ mounted }) {
            if (!mounted) {
                return '';
            }
            let debug = IS_DEBUG ? '&chime-debug=1' : '';
            return `https://site-user.chime.me/chime-site/third/login?theme=${this.showTheme}&fb=${this.enableFb}&g=${this.enableGoogle}&fbBtnText=${this.fbBtnText}&gBtnText=${this.googleBtnText}&v1${debug}`;
        },
        ...rootMapState(usePageStore, {
            globalData: store => store.page,
        }),
        showTheme({ globalData }) {
            let customConfig = globalData?.customConfig || {};
            return customConfig.thirdLoginTheme || globalData?.thirdLoginTheme || this.theme || 'standard';
        }
    },
    created: function() {
        this.onMessage = ({ data }) => {
            if (data.type === 'size') {
                this.height = data.height;
                this.$emit('resize', data);
            } else if (data.type === 'auth') {
                this.$emit('auth', data);
            } else if (data.type === 'auth_facebook_app') {
                //  in the case of  ios  cell phone in  facebook app  in ， You need to open a new page authorization
                window.location.href = `https://site-user.chime.me/chime-site/third/login-middle?callback=${encodeURIComponent(
                    window.location.href
                )}`;
            }
        };
        window.addEventListener('message', this.onMessage);
    },
    mounted() {
        this.mounted = true;
    },
    beforeUnmount: function() {
        window.removeEventListener('message', this.onMessage);
    }
};
</script>
